import React ,{useState,useEffect} from 'react'
export default function PanelPrincipalCorreosMasivos(){
return(
    <div>
        <h1>
            CORREOS MASIVOS
        </h1>
    </div>
)

}